import { useGA4Tracking } from '@hooks/useGA4Tracking';
import DownloadArrow from '@img/icons/download-with-line.svg';
import ChevronDown from '@img/icons/icon-chevron-down.svg';
import { RootState } from '@state/ducks';
import { Column, Grid } from '@stories/Settings/Grids/Grid.styles';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import s from './FooterDownloads.styles';

export interface FooterDownloadsProps {
  items: CTAModel[];
  translations: Record<string, string | undefined>;
}

const FooterDownloads: React.FC<FooterDownloadsProps> = ({ items, translations }) => {
  const [active, setActive] = useState<boolean>(false);
  const modelCode = useSelector<RootState, string>((state) => state.productDetail.modelCode);
  const variants = useSelector<RootState, SimpleProductVariantViewModel[]>((state) => state.productDetail.variants);
  const selectedVariantAgilityId = useSelector<RootState, number | null>(
    (state) => state.productDetail.selectedVariantAgilityId,
  );
  const { fileDownload } = useGA4Tracking();
  const selectedVariant = variants.find((variant) => variant.agilityId === selectedVariantAgilityId);

  return (
    <s.Wrapper>
      <Grid.Default>
        <Column.Full>
          <s.TitleAccordian onClick={() => setActive(!active)}>
            <span>{translations['downloads']}</span>
            <s.Icon
              initial={{ rotate: 0 }}
              animate={active ? { rotate: -180 } : { rotate: 0 }}
              transition={{
                duration: 0.3,
                ease: 'easeInOut',
              }}
            >
              <ChevronDown />
            </s.Icon>
          </s.TitleAccordian>
          <s.Title>{translations['downloads']}</s.Title>
          <s.List
            key="downloads"
            initial={{ height: 0, marginBottom: 0 }}
            animate={active ? { height: 'auto', marginBottom: 16 } : { height: 0, marginBottom: 0 }}
            transition={{
              duration: 0.3,
              ease: 'easeInOut',
            }}
          >
            {items.map((item) => (
              <s.Item key={item.id}>
                <s.Link
                  href={item.url}
                  target={item.target ?? '_self'}
                  onClick={() =>
                    fileDownload({ linkUrl: item.url, itemName: modelCode, itemVariant: selectedVariant?.name })
                  }
                >
                  {item.text} <DownloadArrow />
                </s.Link>
              </s.Item>
            ))}
          </s.List>
        </Column.Full>
      </Grid.Default>
    </s.Wrapper>
  );
};

export default FooterDownloads;
